import PropTypes from 'prop-types'
import classNames from 'classnames'

import Title from 'components/Title'
import PostItem from 'components/PostItem'
import Link from 'components/Link'

import s from './ShowcaseBlock.module.css'

function ShowcaseBlock({ showcase = {}, className = '' }) {
  const linkedShowcase = showcase?.nodes?.[0]
  if (!linkedShowcase) return null

  const {
    // TODO: No longer needed in graphql
    // acfShowcaseSettings: { boardLink },
    acfShowcases: { showcaseTitle, link, subtitle, showcasesGrid },
  } = linkedShowcase
  const setTitle = showcaseTitle ? showcaseTitle.split('\n') : null
  const linkedTo = link?.nodes?.[0]

  return (
    <div className={classNames(s.container, className)}>
      <div className={s.wrapper}>
        <div className={s.header}>
          {setTitle && (
            <Title
              title={setTitle[0]}
              subtitle={setTitle[1] || null}
              borderTitle
              lightSubtitle
            />
          )}
          {linkedTo && subtitle && (
            <Link
              className={s.link}
              href={linkedTo.slug}
              type={linkedTo.__typename}
            >
              {subtitle}
            </Link>
          )}
        </div>
        <div className={s.showcases}>
          {showcasesGrid?.map(({ image, model, brand, publication }) => {
            const linkedModel = model?.nodes?.[0]
            if (!linkedModel?.slug) return null
            const slug = linkedModel.slug
            const title = linkedModel.title
            return (
              <Link key={slug} className={s.showcase} href={slug} type="Model">
                <PostItem
                  image={image?.node?.mediaItemUrl}
                  title={title}
                  brand={(brand?.nodes ?? []).map((b) => b.name).join(', ')}
                  publication={publication?.nodes?.[0]?.name}
                  lightUi
                />
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

ShowcaseBlock.propTypes = {
  showcase: PropTypes.object,
  className: PropTypes.string,
}

export default ShowcaseBlock
